var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.crumbs } },
            [
              _c("w-spacer"),
              _vm.isSaving
                ? _c("w-progress-circular", {
                    staticClass: "mr",
                    attrs: { small: "" },
                  })
                : _vm._e(),
              _vm.$wf.isMdUp
                ? [
                    _c(
                      "w-button",
                      {
                        staticClass: "mr",
                        attrs: { disabled: _vm.isSaving, icon: "save" },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "app-mail-template-edit",
            { attrs: { value: _vm.template } },
            [
              _c(
                "template",
                { slot: "options" },
                [
                  _c(
                    "w-col",
                    { attrs: { md: "6", xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("template-name"), fancy: "" },
                        model: {
                          value: _vm.template.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.template, "Name", $$v)
                          },
                          expression: "template.Name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { md: "6", xs: "12" } },
                    [
                      _vm.canUseReadNotifications()
                        ? _c("w-checkbox", {
                            attrs: { label: _vm.$ct("send-read-confirmation") },
                            model: {
                              value: _vm.template.SendReadConfirmation,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.template,
                                  "SendReadConfirmation",
                                  $$v
                                )
                              },
                              expression: "template.SendReadConfirmation",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "template",
                { slot: "extra-options" },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-file-upload", {
                        attrs: {
                          disabled: !_vm.canUploadAttachment,
                          label: _vm.$ct("default-attachments"),
                          "allowed-extensions": [
                            "jpg",
                            "jpeg",
                            "png",
                            "pdf",
                            "gif",
                          ],
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onFile($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.allFiles, function (file, i) {
                        return _c(
                          "w-chip",
                          {
                            key: i,
                            attrs: { closable: "" },
                            on: {
                              close: function ($event) {
                                return _vm.removeFile(file.value)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(file.text) + " ")]
                        )
                      }),
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }